import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Refresh extends Component {
  render() {
    if(this.props.text){
      return (
        <li>
        <a onClick={this.onClick.bind(this)} style={{cursor:'pointer'}}>
          <i className="material-icons icon" >refresh</i>
          Refresh
        </a>
        </li>
      )
    }
    else {
      return (
        <li>
        <a onClick={this.onClick.bind(this)}>
          <i className="material-icons icon" >refresh</i>
        </a>
        </li>
      )
    }
  }
  onClick(){
    window.location.reload()
  }

}

export default Refresh;
